import { render, staticRenderFns } from "./mogu.vue?vue&type=template&id=49b48ab6&scoped=true"
import script from "./mogu.vue?vue&type=script&lang=js"
export * from "./mogu.vue?vue&type=script&lang=js"
import style0 from "./mogu.vue?vue&type=style&index=0&id=49b48ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b48ab6",
  null
  
)

export default component.exports